export default class Vinculo {
  constructor(id = null, nome = null, ativo = true) {
    this.id = id
    this.nome = nome
    this.ativo = ativo
  }
}
